export default __webpack_public_path__ + "static/media/international.628f93ef.svg";